var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticky z-index-10 ui-bright"},[_c('div',{staticClass:"ui-design__container transparent py-10 px-2 mx-auto d-flex align-center justify-center gap-16"},[_c('layout-header-navigation',{staticClass:"flex-1"}),_c('layout-header-notifications'),_c('layout-header-user-data')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }